import { useState, useEffect } from 'react';

function Admin() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await fetch('/api/auth/verify', {
        credentials: 'include',
      });
      const data = await response.json();
      if (data.authenticated && data.user) {
        setUser(data.user);
      }
    } catch (error) {
      console.error('Failed to fetch user info:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    window.location.href = '/api/auth/logout';
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-cyber-blue border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Welcome Card */}
          <div className="card mb-8">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center">
                {user?.picture && (
                  <img 
                    src={user.picture} 
                    alt={user.name} 
                    className="w-16 h-16 rounded-full mr-4"
                  />
                )}
                <div>
                  <h1 className="text-3xl font-bold text-white">Welcome back, {user?.name}!</h1>
                  <p className="text-gray-400">{user?.email}</p>
                </div>
              </div>
              <button 
                onClick={handleLogout}
                className="btn-secondary"
              >
                Logout
              </button>
            </div>
          </div>

          {/* Coming Soon Card */}
          <div className="card text-center bg-gradient-to-br from-cyber-blue/10 via-cyber-purple/10 to-cyber-pink/10">
            <div className="w-24 h-24 bg-cyber-blue/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-12 h-12 text-cyber-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
              </svg>
            </div>
            
            <h2 className="text-4xl font-bold mb-4">
              <span className="gradient-text">Admin Tools Coming Soon</span>
            </h2>
            
            <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto">
              We're building powerful admin features for you. Future capabilities will include:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto text-left">
              <div className="bg-cyber-darker p-6 rounded-lg border border-gray-800">
                <h3 className="text-lg font-semibold text-white mb-2">🔍 IP Lookup Tools</h3>
                <p className="text-gray-400 text-sm">
                  Advanced IP address analysis and geolocation capabilities
                </p>
              </div>

              <div className="bg-cyber-darker p-6 rounded-lg border border-gray-800">
                <h3 className="text-lg font-semibold text-white mb-2">📊 Analytics Dashboard</h3>
                <p className="text-gray-400 text-sm">
                  Real-time metrics and insights into system performance
                </p>
              </div>

              <div className="bg-cyber-darker p-6 rounded-lg border border-gray-800">
                <h3 className="text-lg font-semibold text-white mb-2">📧 Contact Management</h3>
                <p className="text-gray-400 text-sm">
                  View and manage contact form submissions
                </p>
              </div>

              <div className="bg-cyber-darker p-6 rounded-lg border border-gray-800">
                <h3 className="text-lg font-semibold text-white mb-2">🛡️ Security Tools</h3>
                <p className="text-gray-400 text-sm">
                  Network diagnostics and security analysis utilities
                </p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-800">
              <p className="text-gray-500 text-sm">
                Authentication is working correctly! You're logged in as a verified Velumcloud administrator.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin;
